import { Dropdown } from "antd";
import { CustomMenuProps } from "./types";

export default function Menu({ items, children, disabled }: CustomMenuProps) {
  return (
    <Dropdown menu={{ items }} trigger={["click"]} disabled={disabled}>
      {children}
    </Dropdown>
  );
}
